const moment = require('moment')
require('moment/locale/es')

export const b64Encode = (str) => {
    return window.btoa(decodeURI(encodeURIComponent( str )));
};
export const b64Decode = (str) => {
    return decodeURIComponent(escape(window.atob( str )));
};

export const emailValidator = (v) => {
    if(!v) return ''
    let regex = new RegExp(/.+@.+\..+/).test(v)
    if(!regex) return 'E-mail inválido'
    return true
}

export const rutValidator = (v) => {
    if (!v) return ''
    var value = v.replace(/\,|\-|\./g,'')

    // Aislar Cuerpo y Dígito Verificador
    let body = value.slice(0,-1);
    let dv = value.slice(-1).toUpperCase();

    value = body + '-'+ dv

    if(body.length < 7) return "RUT Incompleto"

    let sum = 0;
    let mult = 2;

    for(var i=1; i<=body.length; i++) {

        let index = mult * value.charAt(body.length - i);
        sum = sum + index;
        if(mult < 7) { mult = mult + 1; } else { mult = 2; }

    }

    let targetDV = 11 - (sum % 11);

    // Casos Especiales (0 y K)
    dv = (dv == 'K')?10:dv;
    dv = (dv == 0)?11:dv;

    if(targetDV != dv) return "RUT Inválido"

    return true

}

export const uuid = () => {
    return Math.random()
        .toString(36)
        .substring(2, 15) + (
            Math.random()
                .toString(36)
                .substring(2, 15)
        );
}

export const rutFormat = rut => {

    if(!rut) return ''

    const cleanRut = rut.trim().replace(/\./g,'').replace('-','').toUpperCase().replace(/^0+/,'')
    const reversed =  cleanRut.split('').reverse()
    if (reversed.length > 2) {
        let dv = reversed[0] || ''
        reversed.shift()
        let reversedFixed = ''
        let j = 0
        reversed.forEach(item => {
            reversedFixed += item
            j++
            if (j === 3) {
                reversedFixed+='.'
                j = 0
            }
        })
        return reversedFixed.split('').reverse().join('') + '-' + dv
    } else {
        return cleanRut
    }
}

export const debounce = (func, wait, immediate = false) => {
    var timeout;
    return function() {
        var context = this, args = arguments;
        var later = function() {
            timeout = null;
            if (!immediate) func.apply(context, args);
        };
        var callNow = immediate && !timeout;
        clearTimeout(timeout);
        timeout = setTimeout(later, wait);
        if (callNow) func.apply(context, args);
    };
};

export const dateFormat = (date = '', words = false) => {
    if (words) {
        return moment(date).format('ddd') + ', ' +
        moment(date).format('D') + ' ' +
        moment(date).format('MMMM') + ' ' +
        moment(date).format('Y') + ''
    }
}

export const preventWindowClose = (prevent = true) => {
    window.onbeforeunload = function() {
        return prevent ? "¿Deseas abandonar este sitio? Hay un trabajo en proceso que podrías perder" : null;
    };
}

export const getFakeAvatar = (gender = 'f') => {

    if(gender === 'o'){
        gender = 'f' // todo get other gender
    }

    const count = {
        f: 28,
        m: 44
    }

    const g = gender || 'm'

    const i = Math.floor(Math.random() * count[g]) + 1

    return `/images/avatars/${g}-avatar-${i}.png`

}

export const filterSelectorWithHeaders = (item, queryText, itemText) => {

    if(typeof item.first_name == 'undefined' || typeof item.specialty == 'undefined'){

        if(typeof item.header !== 'undefined'){
            return item.header.toLocaleLowerCase().indexOf(queryText.toLocaleLowerCase()) > -1
        }

        return false
    }

    return item.first_name.toLocaleLowerCase().indexOf(queryText.toLocaleLowerCase()) > -1 ||
        item.specialty.name.toLocaleLowerCase().indexOf(queryText.toLocaleLowerCase()) > -1
}

export const filterUniqueIds = (array) => {

    const map = new Map();
    const result = [];
    for (const item of array) {
        if(!map.has(item.id)){
            map.set(item.id, true);    // set any value to Map
            result.push(item);
        }
    }

    return result

}

export const moneyConfig = {
    decimal: ',',
        thousands: '.',
        prefix: '',
        precision: 0,
        masked: false /* doesn't work with directive */
}

export const isImageDark = (imageSrc,callback) => {
    var fuzzy = 0.1;
    var img = document.createElement("img");
    img.crossOrigin = "Anonymous";
    img.src = imageSrc;
    img.style.display = "none";
    document.body.appendChild(img);

    img.onload = function() {
        // create canvas
        var canvas = document.createElement("canvas");
        canvas.width = this.width;
        canvas.height = this.height;

        var ctx = canvas.getContext("2d");
        ctx.drawImage(this,0,0);

        var imageData = ctx.getImageData(0,0,canvas.width,canvas.height);
        var data = imageData.data;
        var r,g,b, max_rgb;
        var light = 0, dark = 0;

        for(var x = 0, len = data.length; x < len; x+=4) {
            r = data[x];
            g = data[x+1];
            b = data[x+2];

            max_rgb = Math.max(Math.max(r, g), b);
            if (max_rgb < 128)
                dark++;
            else
                light++;
        }

        var dl_diff = ((light - dark) / (this.width*this.height));
        if (dl_diff + fuzzy < 0)
            callback(true); /* Dark. */
        else
            callback(false);  /* Not dark. */
    }
}
